import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { loyaltyIdNamesByParentChain } from 'main/loyaltyIdNamesByParentChain'
import moment from 'moment'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import subscribersApi from 'services/api/subscribers'
import { emailRegex } from 'utils/helpers'

import styles from './EditGuestDialog.module.scss'

const EditGuestDialog = ({ guest, onClose, onUpdate }) => {
  const { subscriptionId } = guest

  const [firstName, setFirstName] = useState(guest.firstName)
  const [lastName, setLastName] = useState(guest.lastName)
  const [email, setEmail] = useState(guest.email)
  const [loyaltyId, setLoyaltyId] = useState(guest.loyaltyId)

  const [isEmailValid, setIsEmailValid] = useState(null)

  function handleEmailChange(email) {
    setEmail(email)

    if (isEmailValid === false) {
      const isEmailValid = email ? !!email.match(emailRegex) : true
      setIsEmailValid(isEmailValid)
    }
  }

  const [lastCheckOut, setLastCheckOut] = useState(
    moment(guest.lastCheckOut).isBefore(moment('2000-01-01'))
      ? null
      : moment(guest.lastCheckOut).format('YYYY-MM-DD')
  )

  const [isSaving, setIsSaving] = useState(false)
  const [isErred, setisErred] = useState(false)
  const [error, setError] = useState('Something went wrong while updating guest')

  const parentChain = useSelector(s => s.hotelDetails.parentChainCode)

  const loyaltyIdName = loyaltyIdNamesByParentChain[parentChain] || 'Loyalty id'

  function handleSave() {
    setIsSaving(true)

    const isEmailValid = email ? !!email.match(emailRegex) : true

    setIsEmailValid(isEmailValid)

    if (!isEmailValid) {
      setIsSaving(false)
      return
    }

    subscribersApi
      .update({
        bySubscriptionId: subscriptionId,
        firstName,
        lastName,
        email,
        loyaltyId,
        lastCheckout: lastCheckOut ? moment(lastCheckOut).format('YYYY-MM-DD') : null
      })
      .then(() => {
        setisErred(false)
        onUpdate()
      })
      .catch(err => {
        if (err.toString() === 'Error: LoyaltyId already exists!') {
          setError(`This ${loyaltyIdName} already in use by another guest`)
        } else {
          setError('Something went wrong while updating guest')
        }

        setisErred(true)
      })
      .finally(() => {
        setIsSaving(false)
      })
  }

  return (
    <ConfirmationDialog
      title="Edit guest"
      negativeMessage="Cancel"
      positiveMessage="Save changes"
      onClose={onClose}
      onConfirm={handleSave}
      actLikeForm={true}
    >
      <div
        className={styles.form}
        style={{ opacity: isSaving ? 0.7 : 1, pointerEvents: isSaving ? 'none' : 'auto' }}
      >
        <div className={styles.inputHolder}>
          <TextInput
            label="First name"
            value={firstName}
            onChange={e => setFirstName(e.target.value)}
          />
        </div>
        <div className={styles.inputHolder}>
          <TextInput
            label="Last name"
            value={lastName}
            onChange={e => setLastName(e.target.value)}
          />
        </div>
        <div className={styles.inputHolder}>
          <TextInput
            label="Email"
            type="email"
            value={email}
            valid={email ? isEmailValid : null}
            onChange={e => handleEmailChange(e.target.value)}
          />
        </div>
        {isEmailValid === false && (
          <div className={styles.errorText}>
            Enter a valid email address or leave it empty
          </div>
        )}
        <div className={styles.inputHolder}>
          <TextInput
            label={loyaltyIdName}
            value={loyaltyId}
            onChange={e => setLoyaltyId(e.target.value)}
          />
        </div>
        <div className={styles.inputHolder}>
          <TextInput
            label="Checkout date"
            value={lastCheckOut}
            type="date"
            onChange={e => setLastCheckOut(e.target.value)}
          />
        </div>
        {isErred && (
          <p style={{ fontSize: 14, color: 'var(--red)', fontWeight: 500 }}>{error}</p>
        )}
      </div>
    </ConfirmationDialog>
  )
}

export default EditGuestDialog
